import ChannelForm from '../screens/ChannelForm'
import ChannelTabs from '../screens/ChannelTabs'
import ChannelsList from '../screens/ChannelsList'
import { ROLE, RouteWithAccessType } from './types'

const channelPagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/channels',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING,
      ROLE.TENANT_IT,
      ROLE.TENANT_FINANCE,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    requiredFeatures: ['channel.list.view'],
    component: <ChannelsList />
  },
  {
    route: '/channels/create',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['channel.create'],
    component: <ChannelForm />
  },
  {
    route: '/channels/:id/:channelCode/:page',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING,
      ROLE.TENANT_IT,
      ROLE.TENANT_FINANCE,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING,
      ROLE.TENANT_IT,
      ROLE.TENANT_FINANCE
    ],
    requiredFeatures: ['channel.list.view'],
    component: <ChannelTabs />,
    tabs: [
      {
        params: { page: 'details' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.TENANT_IT,
          ROLE.TENANT_FINANCE,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN
        ],
        requiredFeatures: ['channel.details.view']
      },
      {
        params: { page: 'logo' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.ACCOMMODATION,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.TENANT_IT,
          ROLE.TENANT_FINANCE,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN
        ],
        requiredFeatures: ['channel.logo.manage']
      },
      {
        params: { page: 'mapping' },
        rolesListWithReadAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
        rolesListWithWriteAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
        requiredFeatures: ['channel.mapping.manage']
      },
      {
        params: { page: 'api-keys' },
        rolesListWithReadAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
        rolesListWithWriteAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
        requiredFeatures: ['channel.api.keys.manage']
      },
      {
        params: { page: 'push' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['channel.webhook.manage']
      }
    ]
  }
]

export default channelPagesRoleManagement
